import i18next from "i18next";
import ValidationError from "../../common/ValidationError";

export const buildRules = ({
  fieldName,
  fieldType,
  metadata,
  formRef,
  passwordValidationApi,
}) => {
  const rules = [];

  if (metadata?.required) {
    rules.push({
      required: true,
      message: (
        <ValidationError text={i18next.t("general:This field is required")} />
      ),
    });
  }

  if (metadata?.validation?.pattern) {
    rules.push({
      validator: (_, value) => {
        if (!value) {return Promise.resolve();}

        const regex = new RegExp(metadata.validation.pattern);
        return regex.test(String(value))
          ? Promise.resolve()
          : Promise.reject(
            <ValidationError
              text={i18next.t(
                metadata.validation.message || "general:Invalid format"
              )}
            />
          );
      },
    });
  }

  if (fieldName === "nationalId") {
    rules.push({
      validator: (_, value) => {
        if (!value) {return Promise.resolve();}
        const regex = /^[\d\u06F0-\u06F9\u0660-\u0669]{10}$/;
        return regex.test(String(value))
          ? Promise.resolve()
          : Promise.reject(
            <ValidationError
              text={i18next.t(
                "general:National ID must be exactly 10 digits"
              )}
            />
          );
      },
    });
  }

  if (fieldType === "password" && fieldName === "password") {
    rules.push({
      validator: (_, value) =>
        passwordValidationApi.validatePassword(value, metadata)
          ? Promise.resolve()
          : Promise.reject(),
    });
  }

  if (fieldName === "confirm_password") {
    rules.push({
      validator: (_, value) => {
        const password = formRef.current?.getFieldValue("password");
        const newPassword = formRef.current?.getFieldValue("new_password");
        return passwordValidationApi.validateConfirmPassword(
          value,
          password || newPassword,
          metadata
        )
          ? Promise.resolve()
          : Promise.reject();
      },
    });
  }

  return rules;
};
